export function delay(delay = 300) {
  return new Promise((resolve, reject)=> {
    setTimeout(()=> {
      resolve(true);
    }, delay);
  })
}
